var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanetEnlc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 283,
    viewBox: "0 0 282 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_436_366)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274 137.422C274 150.428 272.266 163.435 268.508 175.285C261.572 199.564 248.276 220.952 230.067 237.715C217.35 249.566 202.032 259.104 185.268 265.462C170.238 271.243 153.764 274.422 136.711 274.422C134.399 274.422 131.798 274.422 129.485 274.133C126.017 273.844 122.259 273.555 118.791 273.266C92.4894 269.798 68.2109 258.815 48.846 242.34C41.6202 236.27 34.9726 229.334 28.9029 221.819C24.5675 216.038 20.5211 210.258 16.7638 203.899C15.8967 202.454 15.0295 201.009 14.4515 199.275C13.5844 197.54 12.7173 196.095 12.1393 194.361C9.82704 189.158 7.80381 183.667 6.06964 178.175C4.91352 174.129 3.75738 170.083 2.89029 166.036C2.31224 163.146 1.73418 160.255 1.44515 157.076C0.578059 150.717 0 144.359 0 137.711C0 133.954 3.52733e-05 130.196 0.578094 126.439C0.867124 124.127 1.15612 121.814 1.44515 119.502C3.17932 105.918 6.93676 93.2006 12.4283 81.3504C15.0296 75.5698 18.2089 69.7891 21.6772 64.2975C27.4578 55.3376 34.1055 46.9557 41.9093 39.73C66.4768 15.7405 100.293 1 137.289 1C138.734 1 140.179 1 141.624 1C143.07 1 144.804 1.00002 146.249 1.28905C154.053 1.86711 161.857 3.02322 169.082 4.7574C173.418 5.91352 177.753 7.06965 181.8 8.5148C184.69 9.38188 187.291 10.538 190.181 11.6941C192.205 12.5612 194.228 13.4283 196.251 14.2954C196.54 14.5844 196.829 14.5845 197.407 14.8735C210.703 21.2321 222.842 29.903 233.247 40.3081C234.692 41.7532 236.137 43.1984 237.582 44.9326C238.449 46.0887 239.605 46.9558 240.472 48.1119C241.918 49.8461 243.652 51.8693 245.097 53.6035C250.589 60.5402 255.213 68.0549 259.259 75.8587C263.884 85.1077 267.641 94.9347 270.243 105.051C272.555 114.878 274 126.15 274 137.422Z",
    fill: "url(#paint0_radial_436_366)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197 13.4556C196.421 13.4556 196.132 13.4556 195.554 13.7453C194.107 14.035 192.661 13.7453 191.214 13.4556C190.057 13.1659 189.479 12.5867 188.032 12.5867C186.297 12.297 184.85 11.7176 183.115 11.4279C181.379 11.1383 179.932 10.5589 178.197 9.9796C176.75 9.40026 176.172 9.68993 175.015 9.9796C173.858 10.2693 172.99 9.68998 171.833 9.40032C170.675 8.82099 169.229 8.82098 168.072 8.53131C164.601 7.95198 161.129 6.7933 157.658 5.9243C155.633 5.34497 153.608 5.34498 151.294 5.34498C149.558 5.34498 148.112 5.9243 146.376 5.9243C145.219 5.9243 144.351 5.63466 143.194 5.63466C142.037 5.345 140.88 5.63466 139.723 5.63466C137.987 5.345 137.119 5.05533 135.383 5.63466C133.937 5.92433 133.069 5.92432 131.623 6.21398C130.176 6.21398 128.44 6.79332 126.994 7.08299C124.391 7.66232 121.498 8.24163 118.894 8.24163C117.159 8.24163 114.844 7.6623 113.398 8.24163C112.53 8.5313 111.952 9.68995 111.084 10.2693C109.637 11.7176 108.191 12.8762 107.034 14.3246C105.877 15.7729 104.72 17.5109 104.72 19.5386C104.72 21.2766 105.587 23.3042 106.455 24.7525C107.323 26.4905 107.612 27.9389 105.877 29.0975C103.852 30.5458 101.248 31.7045 98.9339 32.5735C97.1983 33.1529 95.7519 33.4425 94.5947 32.2839C94.0162 31.9942 93.7269 31.1252 93.1483 30.5458C92.5698 30.2562 91.7019 30.5459 91.1233 30.8355C89.3877 31.4149 87.652 31.9942 85.9163 32.2839C84.7592 32.5735 83.8913 33.1528 82.7342 33.1528C81.5771 33.4425 80.7092 32.5736 79.2628 32.8632C77.5271 33.1529 75.5022 34.0219 73.7665 34.0219C72.3201 34.0219 70.5844 33.4426 69.4273 32.8632C68.8487 32.5736 68.5594 31.9942 67.6916 32.2839C67.113 32.2839 66.2453 33.1528 65.956 33.7322C65.3774 34.3115 65.3774 35.1805 64.7988 35.7599C64.2202 36.6289 63.931 37.2082 63.3524 38.0772C62.4846 39.5255 61.6167 40.9738 60.7489 42.4221C60.1703 43.2911 59.5918 44.7395 58.724 45.6085C58.4347 46.1878 57.5668 46.4774 56.9883 46.7671C55.5419 47.6361 54.0955 48.7948 52.6491 49.6638C50.0456 51.6914 47.442 54.0088 44.8385 56.0364C42.8135 57.4848 39.9207 58.3537 37.6065 59.5124C36.1601 60.0917 34.7137 60.671 33.2673 61.2504C32.6887 61.54 31.8208 61.54 31.5315 62.1193C30.953 62.6987 30.6637 63.278 30.3744 64.147C29.2173 65.5954 27.771 67.3334 26.9031 69.0714C26.3246 70.23 26.0353 71.099 25.4567 72.2576C24.8782 73.7059 24.0103 75.1543 23.721 76.8923C22.5639 80.0786 22.5639 83.5546 21.1175 86.7409C20.539 88.4789 19.3818 90.2169 18.5139 91.9549C17.0675 94.8516 16.7783 98.3275 16.489 101.514C16.1997 103.252 16.489 105.569 16.7783 107.307C17.0676 109.335 17.0675 111.362 17.0675 113.39C17.0675 115.418 15.6211 117.735 14.464 119.183C13.3069 120.632 11.2819 121.211 9.83552 122.659C8.6784 123.818 7.23206 124.977 6.6535 126.715C6.36422 127.294 6.6535 128.163 6.6535 129.032C6.36422 130.77 5.78561 132.218 5.78561 133.956C5.49633 135.984 5.49631 138.012 5.49631 140.329C5.49631 141.488 5.49631 142.357 5.49631 143.515C5.49631 144.674 5.78563 145.543 6.07491 146.412C6.07491 146.991 6.07491 147.86 6.07491 148.44C6.07491 149.309 6.6535 150.178 6.6535 150.757C7.23206 152.785 7.52133 154.523 7.81061 156.55C8.09989 158.288 8.96773 160.026 9.25701 161.764C10.1249 164.082 10.4141 166.399 10.9927 169.006C11.282 170.744 11.2819 172.771 11.5712 174.509C11.8605 175.958 12.1498 177.406 12.1498 178.854C12.1498 181.172 11.5712 183.199 11.5712 185.517C11.5712 189.282 13.0177 193.048 13.8855 196.814C14.1748 197.972 14.464 198.841 14.7533 200C5.20707 181.461 0 160.316 0 138.012C0 110.783 7.81055 85.5823 21.4067 64.4367C27.1923 55.4571 33.8458 47.0568 41.6564 39.8152C66.2452 15.773 100.091 1 137.119 1C140.012 1 143.194 1.00002 146.087 1.28968C164.311 1.00002 181.379 5.92432 197 13.4556Z",
    fill: "url(#paint1_linear_436_366)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9299 186.269C78.9067 179.332 76.5945 171.239 74.2822 162.857C76.3054 170.95 78.6176 178.754 80.9299 186.269Z",
    fill: "url(#paint2_linear_436_366)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8832 260.838C76.8832 260.838 82.3747 218.929 86.4211 218.929C89.6004 218.929 95.092 225.288 106.075 233.669C109.254 235.982 112.723 238.583 116.769 241.184C120.238 243.497 124.573 245.809 129.487 248.121C137.579 251.878 147.117 255.925 155.499 259.104C169.084 264.307 180.067 267.775 180.067 267.775L182.09 266.33C182.09 266.33 172.552 264.307 159.835 259.971C159.835 259.971 173.13 238.294 190.183 218.64C207.235 198.986 272.845 152.741 272.845 152.741L273.423 146.093C273.423 146.093 254.636 161.701 233.826 178.176C233.826 178.176 247.699 82.7959 252.035 67.4773L247.699 65.7431C247.699 65.7431 237.294 159.678 226.022 184.534C206.368 200.142 186.425 214.883 180.934 216.617C168.505 220.663 122.839 183.956 122.55 183.956C121.394 146.093 122.261 103.895 125.44 92.912C171.974 48.6904 216.773 26.7241 216.773 26.7241L214.75 24.7009C214.75 24.7009 170.24 55.9161 168.794 50.1355C167.349 44.0659 196.83 14.0068 196.83 14.0068L193.362 13.4288C193.362 13.4288 160.702 55.3381 115.613 99.5596C83.8199 130.775 73.1258 140.313 69.6574 143.203C63.8768 110.543 63.5879 76.1482 73.1258 53.8929C91.0456 12.2726 116.191 2.73462 116.191 2.73462C112.145 2.73462 103.474 4.75782 103.474 4.75782C103.474 4.75782 91.0456 19.4983 85.5541 28.1692C80.3515 36.8401 73.1258 53.6039 68.7904 51.0026C64.4549 48.4014 51.4486 30.1925 51.4486 30.1925L50.0035 31.6376C50.0035 31.6376 62.4317 43.4879 64.7439 52.4478C67.0561 61.4077 65.0329 117.479 59.2524 115.167C53.4718 113.144 13.0076 78.4605 13.0076 78.4605L11.5625 81.3508C11.5625 81.3508 54.0498 110.254 59.2524 120.659C61.8536 125.572 68.2123 144.359 73.7038 162.857C73.1258 160.256 71.1025 151.007 71.9696 147.25C86.1321 126.15 102.318 115.456 118.214 99.5596C121.683 119.214 121.683 188.292 121.394 222.397L105.497 230.201C100.873 225.866 96.8262 221.241 93.6468 216.039C89.0224 208.235 84.398 197.83 80.3516 186.269C82.6638 195.229 84.3979 201.876 84.3979 203.899C84.3979 210.836 73.9929 259.971 73.9929 259.971L76.8832 260.838ZM233.826 178.465C231.514 180.488 228.913 182.222 226.6 184.245L233.826 178.465ZM122.839 185.402V188.292C122.839 187.136 122.839 186.269 122.839 185.402ZM122.839 188.292C122.839 188.292 166.771 215.461 173.997 220.663C180.645 225.288 159.257 254.191 156.077 258.526C147.695 255.347 138.157 251.589 128.908 246.387C126.018 238.294 123.995 214.883 122.839 188.292ZM121.683 224.999C121.683 235.404 121.394 242.051 121.394 242.051C116.769 239.161 112.145 235.693 108.098 232.224C110.989 229.623 116.769 225.577 121.683 224.999Z",
    fill: "url(#paint3_linear_436_366)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0654 174.996C36.7067 165.747 0 132.798 0 132.798V141.469C0 141.469 33.2384 161.123 42.1983 177.308C51.1582 193.494 41.6202 236.271 41.6202 236.271L45.0886 239.739C45.3776 239.739 52.3143 188.581 43.0654 174.996Z",
    fill: "url(#paint4_linear_436_366)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.606 2.73448C152.606 2.73448 162.144 43.4877 199.429 94.0679C236.714 144.648 271.687 161.701 271.687 161.701L273.132 152.741C273.132 152.741 241.049 147.538 203.476 97.5363C159.543 39.1522 159.832 2.44543 159.832 2.44543L152.606 2.73448Z",
    fill: "url(#paint5_linear_436_366)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.44 140.602C122.55 130.196 106.653 3.89038 106.653 3.89038L103.763 4.46848C103.763 4.46848 128.619 128.173 107.809 131.642C91.3345 134.532 7.22689 93.2006 7.22689 93.2006L5.20374 99.2702C5.20374 99.2702 109.832 131.931 148.851 166.036C162.147 177.597 173.419 190.893 182.668 203.899C187.003 209.969 182.668 218.062 175.442 218.351C67.923 219.218 1.73535 161.412 1.73535 161.412L2.6024 166.036C2.6024 166.036 68.2122 200.72 61.5645 204.477C54.9168 208.234 16.7649 204.477 16.7649 204.477L19.0771 208.524C19.0771 208.524 49.7142 205.922 89.3112 211.414C122.839 216.038 179.199 222.975 195.963 224.998C204.634 240.606 208.97 252.456 207.524 255.057L214.172 251.011C203.478 220.952 205.79 187.135 221.687 185.112C237.583 183.378 263.885 188.87 263.885 188.87L266.486 181.644C178.91 185.401 128.619 151.007 125.44 140.602ZM121.394 144.648C118.792 144.648 108.965 137.422 110.121 136.266C111.278 135.11 117.347 121.526 119.37 123.26C121.394 125.283 123.706 144.359 121.394 144.648ZM65.6109 203.899C65.6109 203.899 66.1889 201.876 67.056 201.587C67.9231 201.298 85.843 207.367 84.6868 208.235C83.8198 209.102 65.6109 206.211 65.6109 203.899ZM201.744 211.703C195.096 211.125 155.499 174.129 162.147 170.95C167.06 168.637 202.9 177.019 206.079 183.956C208.97 190.893 208.102 212.281 201.744 211.703Z",
    fill: "url(#paint6_linear_436_366)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.652 3.89059C106.652 3.89059 118.214 128.173 121.682 138.579C125.15 149.273 156.076 168.638 168.794 170.95C181.511 173.262 213.593 185.112 221.975 184.534C230.357 184.245 266.775 181.066 266.775 181.066L271.688 161.412C271.688 161.412 203.766 108.808 179.777 60.8295C155.787 12.8506 156.365 1.57839 156.365 1.57839L145.96 0.422241C145.96 0.422241 171.973 50.7134 179.777 74.992C187.292 99.5595 219.663 123.549 234.114 137.711C248.566 151.874 244.23 176.441 226.889 175.285C209.258 174.129 149.429 177.598 134.688 132.22C128.33 112.566 122.549 93.4899 118.214 60.5405C113.3 28.4581 106.652 3.89059 106.652 3.89059Z",
    fill: "url(#paint7_radial_436_366)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48962 98.9815C5.48962 98.9815 52.3125 116.901 70.2323 129.041C88.1521 141.18 136.42 155.053 146.536 165.747C156.652 176.442 173.994 196.096 172.549 205.634C171.103 214.883 110.407 208.235 86.1289 199.275C61.8504 190.315 21.3863 171.817 15.8947 162.857C10.4031 154.186 0.576172 148.695 0.576172 148.695L2.02132 161.123C2.02132 161.123 62.4284 201.009 70.5212 204.188C78.6141 207.368 161.277 222.975 184.399 218.64C184.399 218.64 195.382 209.391 155.207 169.505C139.021 153.608 110.118 140.602 83.2386 128.463C43.3525 110.254 6.35676 96.0912 6.35676 96.0912L5.48962 98.9815Z",
    fill: "url(#paint8_radial_436_366)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.681 5.04678C171.681 5.04678 174.86 40.5975 186.421 69.7895C197.983 98.9815 220.527 103.895 230.065 114.878C239.892 125.572 265.326 140.024 273.708 134.243L273.13 156.787C273.13 156.787 181.508 120.37 156.073 1.86743L171.681 5.04678Z",
    fill: "url(#paint9_radial_436_366)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.168 219.218C27.168 219.218 66.1871 208.524 113.588 215.75C175.151 224.999 188.158 229.623 193.649 236.271C199.141 242.918 201.164 258.526 201.164 258.526L207.811 254.769C207.811 254.769 204.343 224.42 197.117 219.507C189.892 214.593 131.797 224.709 70.8115 204.188L19.6533 207.946L27.168 219.218Z",
    fill: "url(#paint10_radial_436_366)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.258 182.222C206.657 175.286 168.505 165.748 162.146 170.95C156.944 175.286 191.049 214.594 199.431 215.75C207.813 216.906 211.859 189.159 209.258 182.222ZM195.385 203.9C185.558 202.165 163.013 179.043 167.927 174.419C171.973 170.661 202.61 180.488 204.923 186.269C206.946 192.049 205.212 205.923 195.385 203.9Z",
    fill: "url(#paint11_radial_436_366)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_436_366",
    x: 0,
    y: 0.422241,
    width: 282,
    height: 282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_436_366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_436_366",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_436_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1233 73.3748) scale(242.028 242.029)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#FF7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2092,
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    stopColor: "#FF4646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5102,
    stopColor: "#FA1A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6441,
    stopColor: "#EB0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7704,
    stopColor: "#D41212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8771,
    stopColor: "#B8061B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#750505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_436_366",
    x1: -0.00520705,
    y1: 99.2035,
    x2: 197.139,
    y2: 99.2035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#FFF9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2899,
    stopColor: "#E4FFAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    stopColor: "#FFB7AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6749,
    stopColor: "#A3FF78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8407,
    stopColor: "#FFE76A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    stopColor: "#FF4E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9FAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_436_366",
    x1: 81.7528,
    y1: 170.365,
    x2: 73.5012,
    y2: 178.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_436_366",
    x1: 227.869,
    y1: 37.4988,
    x2: 40.1775,
    y2: 225.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#FEFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2899,
    stopColor: "#DDFFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    stopColor: "#A6DFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536023,
    stopColor: "#B7CCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6749,
    stopColor: "#EF8EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8407,
    stopColor: "#E5C4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    stopColor: "#FF4E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A880FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_436_366",
    x1: 39.173,
    y1: 169.965,
    x2: -0.0000577217,
    y2: 207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#9C8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2899,
    stopColor: "#D7E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    stopColor: "#FFF6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6749,
    stopColor: "#9AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    stopColor: "#FF4E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_436_366",
    x1: 152.51,
    y1: 82.0373,
    x2: 273.137,
    y2: 82.0373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#FF9D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2264,
    stopColor: "#FD9A87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3842,
    stopColor: "#F8918D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5237,
    stopColor: "#EE8198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6527,
    stopColor: "#E16AA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7744,
    stopColor: "#CF4DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#BA2AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#A100EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A100EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_436_366",
    x1: 2.01831,
    y1: 129.16,
    x2: 266.683,
    y2: 129.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#A5FF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2124,
    stopColor: "#D2F488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8CF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#FFCEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6111,
    stopColor: "#E588A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#D76BB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8337,
    stopColor: "#C547C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9364,
    stopColor: "#B01EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A100EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_436_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.632 139.399) scale(99.0854 99.0855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4EAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_436_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.939 195.882) scale(101.196 101.197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CB8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_436_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.996 118.566) scale(74.3762 74.3763)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EEEFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_436_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.217 245.048) scale(97.8064 97.8065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DF3F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_436_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.377 207.015) scale(29.3006 29.3007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE71E3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetEnlc);
export default __webpack_public_path__ + "static/media/PlanetENLC.8643b054a26072c0a7c19029da8013ac.svg";
export { ForwardRef as ReactComponent };